import wx from 'weixin-js-sdk';
import axios from 'axios';

export function getWxData(wxConfigObj) {
  // 配置微信分享
  const wxData = {
    signature: '',
    appId: '',
    nonceStr: '',
    timestamp: '',
  };
  const url = wxConfigObj.url || location.href;
  const queryUrl = `https://authn.bnq.com.cn/authnAdmin/open/wx/getJsSdk.do?url=${encodeURIComponent(url)}`;

  axios
    .get(queryUrl)
    .then((response) => {
      const {
        status,
        data: { code, data },
      } = response;
      if (status === 200 && code === 0) {
        console.log('微信分享接口返回', data);
        wxData.signature = data.signature;
        wxData.appId = data.appId;
        wxData.nonceStr = data.nonceStr;
        wxData.timestamp = data.timestamp;
        wx.config({
          debug: false,
          appId: wxData.appId,
          timestamp: wxData.timestamp,
          nonceStr: wxData.nonceStr,
          signature: wxData.signature,
          jsApiList: ['checkJsApi', 'updateTimelineShareData', 'updateAppMessageShareData', 'navigateToMiniProgram'],
          openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'],
        });
        wx.ready(() => {
          // 分享朋友圈，QQ空间
          wx.updateTimelineShareData({
            title: wxConfigObj.title,
            desc: wxConfigObj.desc,
            link: wxConfigObj.link,
            imgUrl: wxConfigObj.imgUrl,
            success() {},
            cancel() {},
          });
          // 分享朋友，QQ
          wx.updateAppMessageShareData({
            title: wxConfigObj.title,
            desc: wxConfigObj.desc,
            link: wxConfigObj.link,
            imgUrl: wxConfigObj.imgUrl,
            success() {},
            cancel() {},
          });
          wx.error((e) => {
            console.log('🚀 ~ file: weixin.js ~ line 70 ~ wx.error ~ e', e);
          });
          wx.checkJsApi({
            jsApiList: ['updateTimelineShareData', 'wx-open-launch-weapp'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success(res) {
              console.log('🚀 ~ file: weixin.js ~ line 68 ~ success ~ res', res);
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
            },
          });
        });
      }
    })
    .catch((err) => {
      console.error(err);
    });
}
